import { VApp } from 'vuetify/lib/components/VApp';
import { VResponsive } from 'vuetify/lib/components/VResponsive';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VResponsive,[(_vm.theme === 1)?_c('list-theme0001',{attrs:{"list-product":_vm.productGroup,"list-combo":_vm.productCombo,"page":_vm.params.page,"scroll-to":_vm.scroll_to,"on-scroll":_vm.onScrollProduct,"on-scroll-combo":_vm.onScrollCombo,"is-loading":_vm.isLoading}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }